import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import companyLogo from "../assets/images/gymfitorangelogo22.png";

// ==========================================
// HEADER
// ==========================================

const addHeader = (doc) => {
  // Company Logo
  try {
    doc.addImage(companyLogo, "PNG", 15, 10, 26, 26);
  } catch (err) {
    console.log(err);
  }

  // Company Name
  doc.setFont("helvetica", "bold");
  doc.setFontSize(24);
  doc.setTextColor(255, 120, 0);

  doc.text("NN FIT", 105, 18, {
    align: "center",
  });

  // Tagline
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(90);

  doc.text("Gym Management Software", 105, 25, {
    align: "center",
  });

  doc.text("IT Towers, 1st Floor, Near New Collector Office", 105, 32, {
    align: "center",
  });

  doc.text("Nizamabad, Telangana - 503001", 105, 38, {
    align: "center",
  });

  doc.text("Phone : +91 8688663447", 105, 44, {
    align: "center",
  });

  doc.text("Email : info@nnfit.in", 105, 50, {
    align: "center",
  });

  doc.text("Website : www.nnfit.in", 105, 56, {
    align: "center",
  });

  doc.setDrawColor(255, 120, 0);
  doc.setLineWidth(0.8);

  doc.line(15, 63, 195, 63);
};

// ==========================================
// FOOTER
// ==========================================

const addFooter = (doc) => {
  const pageHeight = doc.internal.pageSize.getHeight();

  doc.setDrawColor(220);

  doc.line(15, pageHeight - 18, 195, pageHeight - 18);

  doc.setFontSize(10);
  doc.setTextColor(120);

  doc.text("Powered By NN FIT", 15, pageHeight - 10);

  doc.text(`Generated : ${new Date().toLocaleString()}`, 105, pageHeight - 10, {
    align: "center",
  });

  doc.text("Page 1", 180, pageHeight - 10);
};

// ==========================================
// MAIN FUNCTION
// ==========================================

export const generateInvoice = (invoice) => {
  const doc = new jsPDF();

  addHeader(doc);

  // Invoice Title

  doc.setFont("helvetica", "bold");

  doc.setFontSize(22);

  doc.setTextColor(40);

  doc.text("PAYMENT INVOICE", 105, 78, {
    align: "center",
  });

  // Invoice Box

  doc.setFillColor(248, 248, 248);

  doc.roundedRect(15, 86, 180, 28, 3, 3, "F");

  doc.setFontSize(11);

  doc.setTextColor(80);

  doc.text(`Invoice No : ${invoice.invoiceNo}`, 22, 98);

  doc.text(`Invoice Date : ${new Date().toLocaleDateString()}`, 22, 106);

  doc.text(`Payment ID : ${invoice.paymentId}`, 110, 98);

  doc.text(`Status : ${invoice.paymentStatus}`, 110, 106);
  // ==========================================
  // THANK YOU SECTION
  // ==========================================

  autoTable(doc, {
    startY: 122,

    head: [["Customer Details", ""]],

    body: [
      ["Gym Name", invoice.gymName || "-"],
      ["Owner Name", invoice.ownerName || "-"],
      ["Email", invoice.email || "-"],
      ["Phone", invoice.phone || "-"],
    ],

    theme: "grid",

    headStyles: {
      fillColor: [255, 120, 0],
      textColor: [255, 255, 255],
    },

    styles: {
      fontSize: 10,
      cellPadding: 4,
    },
  });

  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 10,

    head: [["Subscription Details", "Value"]],

    body: [
      ["Plan", invoice.plan || "-"],

      ["Amount", `Rs. ${Number(invoice.amount || 0).toLocaleString("en-IN")}`],

      ["Payment Status", invoice.paymentStatus || "-"],

      ["Payment ID", invoice.paymentId || "-"],

      ["Start Date", invoice.subscriptionStartDate || "-"],

      ["Expiry Date", invoice.subscriptionEndDate || "-"],
    ],

    theme: "grid",

    headStyles: {
      fillColor: [255, 120, 0],
      textColor: [255, 255, 255],
      fontStyle: "bold",
    },

    styles: {
      fontSize: 10,
      cellPadding: 4,
    },

    alternateRowStyles: {
      fillColor: [248, 248, 248],
    },
  });

  let finalY = doc.lastAutoTable.finalY + 18;

  doc.setFillColor(255, 248, 235);

  doc.roundedRect(15, finalY, 180, 35, 3, 3, "F");

  doc.setFont("helvetica", "bold");

  doc.setFontSize(15);

  doc.setTextColor(255, 120, 0);

  doc.text("Thank You!", 105, finalY + 10, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");

  doc.setFontSize(11);

  doc.setTextColor(70);

  doc.text(
    "Thank you for choosing NN FIT Gym Management Software.",
    105,
    finalY + 18,
    {
      align: "center",
    },
  );

  doc.text("Your payment has been received successfully.", 105, finalY + 25, {
    align: "center",
  });

  // ==========================================
  // TERMS & CONDITIONS
  // ==========================================

  finalY += 48;

  doc.setFont("helvetica", "bold");

  doc.setFontSize(13);

  doc.setTextColor(255, 120, 0);

  doc.text("Terms & Conditions", 15, finalY);

  doc.setFont("helvetica", "normal");

  doc.setFontSize(10);

  doc.setTextColor(80);

  doc.text(
    "• This invoice is generated electronically and does not require a physical signature.",
    18,
    finalY + 8,
  );

  doc.text(
    "• Subscription becomes active immediately after successful payment.",
    18,
    finalY + 15,
  );

  doc.text("• Please keep this invoice for your records.", 18, finalY + 22);

  // ==========================================
  // AUTHORIZED SIGNATURE
  // ==========================================

  doc.setDrawColor(180);

  doc.line(145, finalY + 28, 190, finalY + 28);

  doc.setFont("helvetica", "bold");

  doc.setFontSize(11);

  doc.text("Authorized Signature", 167, finalY + 35, {
    align: "center",
  });

  // ==========================================
  // FOOTER
  // ==========================================

  addFooter(doc);

  // ==========================================
  // SAVE PDF
  // ==========================================

  doc.save(`${invoice.invoiceNo}.pdf`);
};
